import type { FetchOptions } from 'ofetch';

export async function fetchApi<T = any>(url: string, options: FetchOptions & { method: 'GET' | 'POST' | 'PUT' | 'DELETE' }) {
    try {
        return await useNuxtApp().$apiFetch<T>(url, { ...options, baseURL: options.baseURL ?? useRuntimeConfig().public.apiBaseURL });
    } catch (error) {
        throw createApiFetchError(error);
    }
}